import { defineCustomElements } from "@tbk-dssy/ui-components-core/loader";
import { tbkSetAssetPath } from '@tbk-dssy/ui-components-core';
tbkSetAssetPath('/wp-content/themes/' + window.tb.WP_DEFAULT_THEME + '/dist/static/tb-design-component-assets', 'body', document.body);
defineCustomElements(window);
